import TutorialScreenPlugin from "@tutorial/TutorialScreenPlugin.tsx";
import {memo} from "react";

const TutorialView = () => {
  return (
    <TutorialScreenPlugin/>
  )
}

export default memo(TutorialView)